import ListingPage from "@components/vpnpricecomparison/listingPage";
import { getPageProps } from "@services/initial-calls";
import { GetServerSideProps } from "next";
import React, { ReactElement } from "react";

export default function VpnPriceComparisonListingPage(): ReactElement {
    return <ListingPage type="listing" />;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "listing");
};
